module.exports = __webpack_public_path__ + "img/logo-datacoress-simbolo.c9173a91.webp";